import { useState, useEffect } from "react"
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Header from "../components/Header";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSackDollar, faMagnifyingGlass, faXmark, faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import { faCreditCard } from '@fortawesome/free-regular-svg-icons'
import Select from "react-select";
import Modal from 'react-modal';
import { useUser } from "../utils/UserContext";
import { getCurrencySymbol, formatCurrency, getRate } from '../utils/currencyUtils';
import { Toaster, toast } from 'react-hot-toast';

function Withdraw() {
  const { user } = useUser();
  const [modalIsOpen, setIsOpen] = useState(false);
  const [error, setError] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [coinbal, setCoinbal] = useState(0);
  const [symbol, setSymbol] = useState();
  const [price, setPrice] = useState();
  const [rate, setRate] = useState(1);
  const currencyCode = user?.currency;
  useEffect(() => {
    let isMounted = true;
    const fetchRate = async () => {
      const r = await getRate(currencyCode);
      if (isMounted) setRate(r);
    };
    fetchRate();
    return () => { isMounted = false; };
  }, [currencyCode]);
  const usdbal = user?.balance;
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  const [withdrawhistorys, setWithdrawhistorys] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedFilter, setSelectedFilter] = useState('all');
  const filteroptions = [
    { value: "all", label: "All" },
    { value: "confirmed", label: "Confirmed" },
    { value: "pending", label: "Pending" },
    { value: "Failed", label: "failed" },
  ];
  const darkThemeStyles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: "#151719",
      border: "none",
      color: "#fff",
      minWidth: "135px"
    }),
    menu: (styles) => ({
      ...styles,
      backgroundColor: "#151719",
    }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      backgroundColor: isSelected ? "rgb(30, 33, 36)" : isFocused ? "rgb(30, 33, 36)" : "#151719",
      color: "#fff",
    }),
    singleValue: (styles) => ({
      ...styles,
      color: "#fff",
    }),
  };
  const filteredHistory = withdrawhistorys.filter(deposithistory => 
    Object.values(deposithistory).some(value => 
        value.toString().toLowerCase().includes(searchTerm.toLowerCase())
    ) && 
    (selectedFilter === 'all' || deposithistory.status.toLowerCase() === selectedFilter.toLowerCase())
  )
  const [typeoptions, setTypeoptions] = useState([]);
  const [assetoptions, setAssetoptions] = useState([]);
  const [type, setType] = useState("Crypto");
  const [asset, setAsset] = useState("");
  const [amount, setAmount] = useState();
  const [camount, setCamount] = useState();
  const [address, setAddress] = useState();
  const [bankname, setBankname] = useState();
  const [accname, setAccname] = useState();
  const [accno, setAccno] = useState();
  const [routineno, setRoutineno] = useState();
  const [info, setInfo] = useState();
  const [activeInfo, setActiveInfo] = useState(false);
  const [loading, setLoading] = useState(false);
  const [disable, setDisable] = useState(true);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchwith: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setWithdrawhistorys(data.trans);
      }
    })
    .catch(err => {
        console.error('Error fetching withdraw transaction!')
    })
  }, [user]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchpayment: true })
    })
    .then(response =>  response.json())
    .then(data => {
      const methodop = []
      if (data.status === "success") {
        data.methods.forEach(method => {
          methodop.push({
            value: method.name,
            label: method.name,
          });
        });
        setTypeoptions(methodop);
      }
    })
    .catch(err => {
      console.error('Error fetching withdraw method!', err);
    })
  }, [user]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchwallet1: true })
    })
    .then(response => response.json())
    .then(data => {
      const methodop = [];
      if (data.status === "success") {
        data.wallet.forEach(address => {
          methodop.push({
            value: address.coinName,
            label: (
              <>
                <img src={address.logo} alt={address.symbol} width="20" style={{ marginRight: 5 }} />
                {address.coinName}
              </>
            ),
            price : address.price,
            balance : address.balance,
            symbol : address.symbol,
          });
        });
        setAssetoptions(methodop);
      }
    })
    .catch(err => {
      toast.error('Error fetching deposit transaction!')
    })
  }, [user]);

  function validateAssets (selected){
    console.log(selected);
    setAsset(selected.value)
    setSymbol(selected.symbol)
    setPrice(selected.price)
    setCoinbal(selected.balance)
  }
  
  function validateAmount (value){
    setAmount(value);
    if((usdbal * rate) < value || usdbal === 0){
      setError(true);
    }else{
      setError(false);
    }
  }
  function validateCamount (value){
    setCamount(value);
    if(coinbal < value || coinbal === 0){
      setError(true);
    }else{
      setError(false);
    }
  }
  useEffect(() => {
    if((type && amount) || (type && camount)){
      setDisable(false);
    }else{
      setDisable(true);
    }
  }, [type, amount, camount]);

  const ValidateWithdraw = () =>{
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}controller/withdraw.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ btn_bank: true, amount: amount, bank_name: bankname, acc_name: accname, acc_no: accno, routineno: routineno})
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setLoading(false);
        setIsOpen(false);
        toast.success(data.result);
        setTimeout(() => {
          window.location.href = "dashboard";
        }, 2000);
      }else{
        toast.error(data.message);
      }
    })
    .catch(err => {
      console.error(err)
      setLoading(false);
      toast.error('There was an issue processing your deposit.')
    })
  }
  const ValidateWithdraw1 = () =>{
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}controller/withdraw.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ btn_crypto: true, method: asset, price : price, amount: camount, wallet_address : address, info : info})
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setLoading(false);
        setIsOpen(false);
        toast.success(data.result);
        setTimeout(() => {
          window.location.href = "dashboard";
        }, 2000);
      }else{
        toast.error(data.message);
      }
    })
    .catch(err => {
      console.error(err)
      setLoading(false);
      toast.error('There was an issue processing your deposit.')
    })
  }
  const ValidateWithdraw2 = () =>{
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}controller/withdraw.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ btn_paypal: true, amount :amount, paypal_address : address})
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setLoading(false);
        setIsOpen(false);
        toast.success(data.result);
        setTimeout(() => {
          window.location.href = "dashboard";
        }, 2000);
      }else{
        toast.error(data.message);
      }
    })
    .catch(err => {
      console.error(err)
      setLoading(false);
      toast.error('There was an issue processing your deposit.')
    })
  }
  const ValidateWithdraw3 = () =>{
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}controller/withdraw.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ btn_skrill: true, amount :amount, skrill_address : address})
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        console.log(data.result);
        setLoading(false);
        setIsOpen(false);
        toast.success(data.result);
        setTimeout(() => {
          window.location.href = "dashboard";
        }, 2000);
      }else{
        toast.error(data.message);
      }
    })
    .catch(err => {
      console.error(err)
      setLoading(false);
      toast.error('There was an issue processing your deposit.')
    })
  }
  return (
    <div className="container-fluid">
      <div className="row g-0">
        <div><Toaster/></div>
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="Withdraw" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar">
          <Header title="Withdraw" icon={<FontAwesomeIcon icon={faSackDollar} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main>
            <div className="row">
                <div className="col-12">
                    <div className="mycard mt-2" style={{minHeight: '88vh'}}>
                        <div className="d-lg-flex align-items-center justify-content-between mb-4">
                            <div className="d-flex align-items-center">
                                <h6 className="mb-0 text-light fw-bold" style={{fontSize: '18px'}}>Withdrawals</h6>
                                <div className="myBtn ms-3 bg-prime px-3" onClick={() => setIsOpen(true)}><FontAwesomeIcon className="me-1" icon={faCreditCard} style={{fontSize: '16px'}} /> Withdraw money</div>
                            </div>
                            <div className="d-flex align-items-center mt-2 mt-lg-0">
                                <div className="d-flex align-items-center form-control justify-content-between me-2 searchcon">
                                    <FontAwesomeIcon className="me-2" icon={faMagnifyingGlass} style={{fontSize: '16px'}} />
                                    <input 
                                    type="text" 
                                    placeholder="Search for withdrawals" 
                                    className="searchinput"
                                    value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                </div>
                                <Select 
                                    options={filteroptions}
                                    value={filteroptions.find((opt) => opt.value === selectedFilter)}
                                    onChange={(e) => setSelectedFilter(e.value)}
                                    styles={darkThemeStyles}
                                    className="w-full"
                                />
                            </div>
                        </div>
                        <div className="table-responsive">
                            <table className="table table-borderless table-dark align-middle">
                                <thead>
                                    <tr className="fs-7">
                                    <th className="fw-normal text-light" style={{width: '150px'}}>Date</th>
                                    <th className="fw-normal text-light">Reference</th>
                                    <th className="fw-normal text-light">Method</th>
                                    <th className="fw-normal text-light">Type</th>
                                    <th className="fw-normal text-light">Amount</th>
                                    <th className="fw-normal text-light">Amount USD</th>
                                    <th className="fw-normal text-light">Status</th>
                                    </tr>
                                </thead>
                                <tbody style={{fontSize: '14px'}}>
                                {filteredHistory.length > 0 ? (
                                    filteredHistory.map((history) => (
                                        <tr>
                                            <td>{history.date}</td>
                                            <td>{history.hash}</td>
                                            <td>{history.method}</td>
                                            <td>{history.type}</td>
                                            <td>{(history.amountCoin)?formatCurrency(history.amountCoin):"--"}</td>
                                            <td>{getCurrencySymbol(user?.currency)}{formatCurrency(history.amount * rate)}</td>
                                            <td>{history.status.charAt(0).toUpperCase() + history.status.slice(1)}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td className="py-5" colSpan={7}>You have not made any withdrawals yet. <span className="text-prime" onClick={() => setIsOpen(true)}>Click here to make a withdrawal.</span></td>
                                    </tr>
                                )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
          </main>
        </div>
        <Modal
            isOpen={modalIsOpen}
            onRequestClose={() => setIsOpen(false)}
            shouldCloseOnOverlayClick={true} 
            closeTimeoutMS={100}
        >
            <div className="d-flex align-items-center justify-content-between">
                <p className="mb-0 fw-bold text-white" style={{fontSize: '15px'}}>Withdraw</p>
                <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen(false)} />
            </div>
            <p className="my-3 text-light fw-semibold" style={{fontSize: '15px'}}>To make a withdrawal, select your balance, amount and verify the address you wish for payment to be made into.</p>
            <label className="fw-semibold mb-1" style={{fontSize: '14px'}}>Type:</label>
            <Select 
                options={typeoptions} 
                value={typeoptions.find((opt) => opt.value === type)}
                onChange={(e) => setType(e.value)}
                styles={darkThemeStyles}
                className="w-full"
            />
            {type === "Crypto" && (
                <>
                    <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Asset:</label>
                    <Select 
                        options={assetoptions} 
                        value={assetoptions.find((opt) => opt.value === asset)}
                        onChange={(selected) => validateAssets(selected)}
                        isSearchable
                        styles={darkThemeStyles}
                        className="w-full"
                    />
                    <p onClick={() => setActiveInfo(prev => !prev)} className="fw-semibold mb-0 text-end mt-1" style={{fontSize: '12px',cursor:'pointer'}}>Additional Info (Memo)</p>
                </>
            )}
            {type === "Crypto" && (
            <>
            <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Amount:</label>
            <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 ${error ? 'input-error' : ''}`}>
                <input 
                    type="text" 
                    placeholder="0.01" 
                    className="inputNone"
                    value={camount}
                    onChange={(e) => validateCamount(e.target.value)}
                />
                <div className="fw-bold text-white d-flex align-items-center" style={{backgroundColor: 'rgb(30, 33, 36)', borderRadius:'4px',padding: '6px',fontSize: '14px', cursor: 'pointer'}}>
                {symbol}
                </div>
            </div>
            {error && (
                <p className="mb-0 text-danger fs-7 mt-1">Your current balance is {formatCurrency(coinbal)} {symbol}. Kindly choose a lower amount or deposit into your account.</p>
            )}
            <div className="d-flex align-items-center justify-content-between mt-1">
                <p className="mb-0 fs-7 text-white">Current balance:</p>
                <p className="mb-0 fs-7 text-white">{formatCurrency(coinbal)} {symbol}</p>
            </div>
            <div className="d-flex align-items-center justify-content-between mt-0">
                <p className="mb-0 fs-7 text-white">Total in {user?.currency}</p>
                <p className="mb-0 fs-7 text-success">{formatCurrency((coinbal * price) * rate)} {user?.currency}</p>
            </div>
            </>)}
            {type != "Crypto" && (
            <>
            <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Amount:</label>
            <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 ${error ? 'input-error' : ''}`}>
                <input 
                    type="text" 
                    placeholder="1000" 
                    className="inputNone"
                    value={amount}
                    onChange={(e) => validateAmount(e.target.value)}
                />
                <div className="fw-bold text-white d-flex align-items-center" style={{backgroundColor: 'rgb(30, 33, 36)', borderRadius:'4px',padding: '6px',fontSize: '14px', cursor: 'pointer'}}>
                {user?.currency}
                </div>
            </div>
            {error && (
                <p className="mb-0 text-danger fs-7 mt-1">Your current balance is {getCurrencySymbol(user?.currency)}{formatCurrency(usdbal * rate)}. Kindly choose a lower amount or deposit into your account.</p>
            )}
            <div className="d-flex align-items-center justify-content-between mt-1">
                <p className="mb-0 fs-7 text-white">Current balance:</p>
                <p className="mb-0 fs-7 text-white">{formatCurrency(usdbal * rate)} {user?.currency}</p>
            </div>
            <div className="d-flex align-items-center justify-content-between mt-0">
                <p className="mb-0 fs-7 text-white">Total in {user?.currency}</p>
                <p className="mb-0 fs-7 text-success">{formatCurrency(usdbal * rate)} {user?.currency}</p>
            </div>
            </>)}
            {type === "Crypto" && (
            <>
                <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Address:</label>
                <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
                    <input 
                    type="text"
                    placeholder={`Your ${asset} address`}
                    className="inputNone w-100 py-1"
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                    />
                </div>
                {activeInfo ===true && (
                <>
                  <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Additional Info:</label>
                  <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
                      <input 
                      type="text"
                      placeholder="Memo"
                      className="inputNone w-100 py-1"
                      value={info}
                      onChange={(e) => setInfo(e.target.value)}
                      />
                  </div>
                </>
                )}
            </>
            )}
            {type === "Paypal" && (
            <>
                <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Your Paypal details:</label>
                <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
                    <input 
                    type="text"
                    placeholder={`Your Paypal details`}
                    className="inputNone w-100 py-1"
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                    />
                </div>
            </>
            )}
            {type === "Skrill" && (
            <>
                <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Your Skrill details:</label>
                <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
                    <input 
                    type="text"
                    placeholder={`Your Skrill details`}
                    className="inputNone w-100 py-1"
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                    />
                </div>
            </>
            )}
            {type === "Bank Transfer" && (
            <>
                <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Bank Name:</label>
                <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
                    <input 
                    type="text"
                    placeholder={`Your Bank Name`}
                    className="inputNone w-100 py-1"
                    value={bankname}
                    onChange={(e) => setBankname(e.target.value)}
                    />
                </div>
                <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Account Name:</label>
                <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
                    <input 
                    type="text"
                    placeholder={`Your Account Name`}
                    className="inputNone w-100 py-1"
                    value={accname}
                    onChange={(e) => setAccname(e.target.value)}
                    />
                </div>
                <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Account Number:</label>
                <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
                    <input 
                    type="text"
                    placeholder={`Your Account Number`}
                    className="inputNone w-100 py-1"
                    value={accno}
                    onChange={(e) => setAccno(e.target.value)}
                    />
                </div>
                <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Routine Number:</label>
                <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
                    <input 
                    type="text"
                    placeholder={`Your Routine Number`}
                    className="inputNone w-100 py-1"
                    value={routineno}
                    onChange={(e) => setRoutineno(e.target.value)}
                    />
                </div>
            </>
            )}
            <div className={`myBtn w-100 text-center mt-3 ${disable?'disabled':null}`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={!disable && type === "Bank Transfer" ? ValidateWithdraw : !disable && type === "Crypto" ? ValidateWithdraw1 : !disable && type === "Paypal" ? ValidateWithdraw2 : !disable && type === "Skrill" ? ValidateWithdraw3 : null}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Withdraw'}</div>
        </Modal>
      </div>
    </div>
  )
}
export default Withdraw